module.exports = __webpack_public_path__ + "static/img/globe-shading.52d8a1f8.svg";